var lists_default = {
  "fontElementMap": "JN-EX",
  "orderedlist": "Cue6N",
  "bulletedlist": "JkaTp",
  "listItem": "Tu0Sq"
};
export {
  lists_default as default
};
//# sourceMappingURL=lists-scss.js.map
